import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from '../layout/public-layout/public-layout.component';
import { LoginComponent } from './login.component';
import { OpenIdLoginComponent } from '../openIdLogin/openIdLogin.component';

const routes: Routes = [
  {
    path: 'login',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: OpenIdLoginComponent },
    ]
  },
  {
    path: 'login',
    component: PublicLayoutComponent,
    children: [
      { path: ':id', component: OpenIdLoginComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
